import { post, postData } from './http'
import global from '@/api/global'
var name = global.dataCenterName
// var name = '/crm'
// // 租户管理-查询
// export const TenantSeatch = p => post(name + '/tenant/getTenantList', p)

// ---------------报表统计--------------------
export const socActiveList = p => post(name + '/socActive/list', p)// 货主数据列表
export const activeStatistical = p => post(name + '/socActive/activeStatistical', p)// 数据统计
export const getMonthStatistics = p => post(name + '/socActive/getMonthStatistics', p)// 货主新增趋势
export const listStatistics = p => post(name + '/socActive/listStatistics', p)// 货主活跃度对比
// export const productNameList = p => post(name + '/dSocWayTransport/productNameList', p)// 平台运价统计-货物分类
// export const getTrafficCountNoGroup = p => post(name + '/dSocWayTransport/getTrafficCountNoGroup', p)// 平台运价统计-数据统计
// export const productWeightList = p => post(name + '/dSocWayTransport/productWeightList', p)// 平台运价统计-重量分类
// export const getTrafficCount = p => post(name + '/dSocWayTransport/getTrafficCount', p)// 平台运价统计-12月波动折线图
// export const getPriceCount = p => post(name + '/dSocWayTransport/getPriceCount', p)// 平台运价统计-运价统计
// 找车-车队报表（常艳）
export const sDemandOrderList = p => post(name + '/sDemandOrder/list', p)
